import * as React from "react";
import type { SVGProps } from "react";
const SvgTabletWithCamcorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-.5a1 1 0 1 1 0-2h.5V4H10v6.5a1 1 0 1 1-2 0z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 14.461V13a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-1.8l2.643 1.468a1.25 1.25 0 0 0 1.857-1.093v-6.19a1.25 1.25 0 0 0-1.758-1.143zM3 14v7h9v-7zm11 2.65v1.262l2.5 1.389v-3.762z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTabletWithCamcorder;
